import { api } from '@/shared/lib/axios.ts';
import type {
  IncidentRow,
  IncidentListResponse,
  IncidentListParams,
  IncidentSeveridade,
  IncidentTipo,
} from '@/shared/types/incident.ts';

export async function listIncidents(params: IncidentListParams): Promise<IncidentListResponse> {
  const { data } = await api.get<IncidentListResponse>('/admin/incidents', { params });
  return data;
}

export async function getIncident(id: string): Promise<IncidentRow> {
  const { data } = await api.get<IncidentRow>(`/admin/incidents/${id}`);
  return data;
}

export interface CreateIncidentDTO {
  titulo: string;
  descricao?: string;
  severidade: IncidentSeveridade;
  tipo: IncidentTipo;
  tenantIds?: string[];
  selectAll?: true;
}

export async function createIncident(input: CreateIncidentDTO): Promise<IncidentRow> {
  const { data } = await api.post<IncidentRow>('/admin/incidents', input);
  return data;
}

export interface CloseIncidentDTO {
  causaRaiz?: string;
}

export async function closeIncident(id: string, input: CloseIncidentDTO): Promise<IncidentRow> {
  const { data } = await api.put<IncidentRow>(`/admin/incidents/${id}/close`, input);
  return data;
}

export interface UpdateIncidentDTO {
  titulo?: string;
  descricao?: string;
  severidade?: IncidentSeveridade;
  tipo?: IncidentTipo;
  addTenantIds?: string[];
  removeTenantIds?: string[];
}

export async function updateIncident(id: string, input: UpdateIncidentDTO): Promise<IncidentRow> {
  const { data } = await api.put<IncidentRow>(`/admin/incidents/${id}`, input);
  return data;
}

export async function deleteIncident(id: string): Promise<IncidentRow> {
  const { data } = await api.delete<IncidentRow>(`/admin/incidents/${id}`);
  return data;
}
